
// 获得所有行业
export function getAllIndustry(that){
    that.axiosGet('/position/findPosition').then((res)=>{
        // console.log(res)
        if(res.code==200){
            
        }
    })
}

// 获得所有薪资
export function getSalary(postMinSalaryArr,postMaxSalaryArr){
    // console.log(postMinSalaryArr)
    // console.log(postMaxSalaryArr)
    for(let i=1;i<=30;i++){
        postMinSalaryArr.push(i+'k')
        postMaxSalaryArr.push(i+'k')
    }
    return {postMinSalaryArr,postMaxSalaryArr}

}

// 基础数据
export function getBasicsData(that,parameter){
    return new Promise((resolve,reject)=>{
            that.axiosGet(`/common/findSysDict?code=${parameter}`).then((res)=>{
                    resolve(res)
            },(rej)=>{
                console.log('error',rej)
            })
    })
}

// 新增公司福利
export function addRelevance(relevanceId,status,name,type){
    return new Promise((resolve,reject)=>{
        that.axiosPost(`/commonRelevance/addRelevance`,
            {
                relevanceId,
                name,
                type,
                status
            }
        ).then((res)=>{
            resolve(res)
        },(rej)=>{
            Promise.reject('error',rej)
        })
    })
}

// 查询公司福利
export function searchRelevance(that,companyId,status,type){
    // console.log('compayId',companyId,'status',status,'type',type)
    return new Promise((resolve,reject)=>{
        that.axiosGet(`/company/findRelevanceByCompanyId?companyId=${companyId}&status=${status}&type=${type}`).then((res)=>{
            resolve(res)
        },(rej)=>{
            Promise.reject('error',rej)
        })
    })

}
// export function getOpenPositions(that,parameter){
//     return new Promise((resolve,reject))
// }
// export async function getBasicsData(that,parameter){
//         let n  = await getBasicsDataInterfece(that,parameter)
//         // console.log('获取到了n')
//         // console.log(n)
//         return n
// }
